<template>
  <div class="pa-4">
    <tenant-grant-form
      :user-id="userId"
      :tenant-id="tenantId"
      @close="onClose"
      @saved="onGrantSaved"
      @on-grant-deleted="onClose"
    />
  </div>
</template>

<script setup>
import { computed, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import TenantGrantForm from "@/views/company/TenantGrantForm.vue";
import { useSnackbar } from "@/plugins/snackbar";
import { useMetaStore } from "@/stores/meta";

const route = useRoute();
const router = useRouter();
const snackbar = useSnackbar();
const metaStore = useMetaStore();

const userId = computed(() => route.params.user_id);
const tenantId = computed(() => route.params.tenant_id);

const onClose = async () => {
  await router.push({
    name: "tenant.grants",
    params: { tenant_id: tenantId.value },
  });
};

const onGrantSaved = async () => {
  snackbar.success("Informacoes salvas com sucesso");
  await onClose();
};

onMounted(() => {
  metaStore.setTitle("Alterar Acesso");
});
</script>
